<template lang="pug">
v-container(fluid='')
  v-container(fluid)
    v-card
      v-tabs(v-model="activeTab")
        v-tab Proveedores
        v-tab Rubros
      v-tabs-items(v-model="activeTab")
        // Tab de Proveedores existente
        v-tab-item
          v-card
            v-card-title.d-flex.justify-space-between
              span Gestión de Proveedores
              v-btn(color='primary', @click='openDialog()')
                v-icon(left='') mdi-plus
                | Nuevo Proveedor
            v-card-text
              v-row(align='center')
                v-col(cols='12', sm='4')
                  v-text-field(v-model='search', label='Buscar proveedor', prepend-inner-icon='mdi-magnify', clearable='')
                v-spacer
              v-data-table(:headers='headers', :items='suppliers', :loading='loading', :search='search')
                template(v-slot:item.categories='{ item }')
                  v-chip.mr-1.mb-1(small='')
                    | {{ categories.find(c => c._id === item.category)?.name }}
                template(v-slot:item.subCategories='{ item }')
                  v-chip.mr-1.mb-1(small='')
                    | {{ getSubCategory(item.category, item.subCategories)?.name }}
                template(v-slot:item.status='{ item }')
                    v-chip(:color="item.active ? 'success' : 'error'", small='')
                      | {{ item.active ? &apos;Activo&apos; : &apos;Inactivo&apos; }}
                template(v-slot:item.actions='{ item }')
                      v-btn.mr-2(icon='', small='', @click='openDialog(item)')
                        v-icon mdi-pencil
                      v-btn(icon='', small='', :color="item.active ? 'error' : 'success'", @click='toggleStatus(item)')
        v-tab-item
          v-card-title.d-flex.justify-space-between
            span Gestión de Rubros
            v-btn(color="primary" @click="openCategoryDialog()")
              v-icon(left) mdi-plus
              | Nuevo Rubro
          v-card-text
            // Búsqueda
            v-text-field(
              v-model="categorySearch"
              label="Buscar rubros"
              prepend-inner-icon="mdi-magnify"
              clearable
              outlined
              dense
              hide-details
              class="mb-4"
            )
            // Lista de Rubros
            v-expansion-panels
              v-expansion-panel(
                v-for="category in filteredCategories"
                :key="category._id"
              )
                v-expansion-panel-header
                  .d-flex.align-center.justify-space-between.flex-grow-1
                    div
                      strong {{ category.code }} - {{ category.name }}
                      v-chip(
                        x-small
                        :color="category.active ? 'success' : 'error'"
                        class="ml-2"
                      ) {{ category.active ? 'Activo' : 'Inactivo' }}
                    // Acciones del Rubro
                    .d-flex
                      v-btn(
                        icon
                        small
                        @click.stop="openCategoryDialog(category)"
                      )
                        v-icon mdi-pencil
                      v-btn(
                        icon
                        small
                        color="error"
                        @click.stop="deleteCategory(category)"
                      )
                        v-icon mdi-delete

                v-expansion-panel-content
                  // Descripción del Rubro
                  .mb-4(v-if="category.description")
                    strong Descripción:
                    |  {{ category.description }}

                  // Subrubros
                  .d-flex.justify-space-between.align-center.mb-4
                    h3.subtitle-2 Subrubros
                    v-btn(
                      small
                      color="primary"
                      @click="openSubCategoryDialog(category)"
                    )
                      v-icon(left small) mdi-plus
                      | Nuevo Subrubro

                  v-data-table(
                    :headers="subCategoryHeaders"
                    :items="category.subCategories"
                    :search="categorySearch"
                    dense
                  )
                    template(v-slot:item.active="{ item }")
                      v-chip(
                        x-small
                        :color="item.active ? 'success' : 'error'"
                      ) {{ item.active ? 'Activo' : 'Inactivo' }}

                    template(v-slot:item.actions="{ item }")
                      v-btn(
                        icon
                        x-small
                        @click="openSubCategoryDialog(category, item)"
                      )
                        v-icon mdi-pencil
                      v-btn(
                        icon
                        x-small
                        color="error"
                        @click="deleteSubCategory(category, item)"
                      )
                        v-icon mdi-delete
                          v-icon {{ item.active ? &apos;mdi-close&apos; : &apos;mdi-check&apos; }}
      // Diálogo de Rubro
      v-dialog(v-model="categoryDialog" max-width="500")
        v-card
          v-card-title {{ editedCategory._id ? 'Editar' : 'Nuevo' }} Rubro
          v-card-text
            v-form(ref="categoryForm" v-model="categoryValid")
              v-text-field(
                v-model="editedCategory.code"
                label="Código"
                :rules="codeRules"
                required
              )
              v-text-field(
                v-model="editedCategory.name"
                label="Nombre"
                :rules="nameRules"
                required
              )
              v-textarea(
                v-model="editedCategory.description"
                label="Descripción"
                rows="3"
              )
              v-switch(
                v-model="editedCategory.active"
                label="Activo"
                color="success"
              )

          v-card-actions
            v-spacer
            v-btn(text @click="closeCategoryDialog") Cancelar
            v-btn(
              color="primary"
              :disabled="!categoryValid"
              @click="saveCategory"
            ) Guardar

      // Diálogo de Subrubro
      v-dialog(v-model="subCategoryDialog" max-width="500")
        v-card
          v-card-title {{ editedSubCategory._id ? 'Editar' : 'Nuevo' }} Subrubro
          v-card-text
            v-form(ref="subCategoryForm" v-model="subCategoryValid")
              v-text-field(
                v-model="editedSubCategory.code"
                label="Código"
                :rules="codeRules"
                required
              )
              v-text-field(
                v-model="editedSubCategory.name"
                label="Nombre"
                :rules="nameRules"
                required
              )
              v-textarea(
                v-model="editedSubCategory.description"
                label="Descripción"
                rows="3"
              )
              v-switch(
                v-model="editedSubCategory.active"
                label="Activo"
                color="success"
              )

          v-card-actions
            v-spacer
            v-btn(text @click="closeSubCategoryDialog") Cancelar
            v-btn(
              color="primary"
              :disabled="!subCategoryValid"
              @click="saveSubCategory"
            ) Guardar
      // Dialog for creating/editing suppliers
      v-dialog(v-model='dialog', max-width='600')
        v-card
          v-card-title
            | {{ editedItem._id ? &apos;Editar&apos; : &apos;Nuevo&apos; }} Proveedor
          v-card-text
            v-form(ref='form', v-model='valid')
              v-row
                v-col(cols='12', sm='6')
                  v-text-field(v-model='editedItem.businessName', label='Razón Social', :rules="[v => !!v || 'La razón social es requerida']", required='')
                v-col(cols='12', sm='6')
                  v-text-field(v-model='editedItem.cuit', label='CUIT', :rules="[v => !!v || 'El CUIT es requerido']", required='')
                v-col(cols='12', sm='6')
                  v-text-field(v-model='editedItem.phone', label='Teléfono', required='')
                v-col(cols='12', sm='6')
                  v-text-field(v-model='editedItem.email', label='Email', type='email')
                v-col(cols='12')
                  v-text-field(v-model='editedItem.address', label='Dirección')
                v-col(cols='12')
                  v-textarea(v-model='editedItem.notes', label='Notas', rows='3')
                v-col(cols='12')
                  v-select(v-model='editedItem.category', :items='categories', item-text='name', item-value='_id', clearable='', dense='', hide-details label='Rubros')
                v-col(cols='12' v-if='editedItem.category')
                  v-select(v-model='editedItem.subCategories', :items='getSubCategories(editedItem.category)', item-text='name', item-value='_id', clearable='', dense='', hide-details='', :label='`Subrubros de ${categories.find(c => c._id === editedItem.category)?.name || ""}`')
                v-col(cols='12')
                  v-switch(v-model='editedItem.active', label='Activo', color='success')
          v-card-actions
            v-spacer
            v-btn(text='', @click='closeDialog')
              | Cancelar
            v-btn(color='primary', :disabled='!valid', @click='save')
              | Guardar
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SuppliersView',
  data: () => ({
    loading: false,
    dialog: false,
    valid: false,
    activeTab: 0,
    categorySearch: '',
    categoryDialog: false,
    subCategoryDialog: false,
    categoryValid: false,
    subCategoryValid: false,
    selectedCategory: null,
    editedCategory: {
      code: '',
      name: '',
      description: '',
      active: true
    },
    editedSubCategory: {
      code: '',
      name: '',
      description: '',
      active: true
    },
    subCategoryHeaders: [
      { text: 'Código', value: 'code' },
      { text: 'Nombre', value: 'name' },
      { text: 'Descripción', value: 'description' },
      { text: 'Estado', value: 'active' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    codeRules: [
      v => !!v || 'El código es requerido',
      v => /^[A-Z0-9]+$/.test(v) || 'Solo mayúsculas y números'
    ],
    nameRules: [
      v => !!v || 'El nombre es requerido'
    ],
    search: '',
    headers: [
      { text: 'Razón Social', value: 'businessName' },
      { text: 'CUIT', value: 'cuit' },
      { text: 'Teléfono', value: 'phone' },
      { text: 'Email', value: 'email' },
      { text: 'Rubro', value: 'categories' },
      { text: 'Subrubro', value: 'subCategories' },
      { text: 'Estado', value: 'status' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    editedItem: {
      businessName: '',
      cuit: '',
      phone: '',
      email: '',
      address: '',
      notes: '',
      active: true,
      category: null,
      subCategories: null
    },
    defaultItem: {
      businessName: '',
      cuit: '',
      phone: '',
      email: '',
      address: '',
      notes: '',
      active: true,
      category: null,
      subCategories: null
    }
  }),
  computed: {
    ...mapState({
      suppliers: state => state.suppliers.list
    }),
    categories() {
      return this.$store.state.supplierCategories.list
    },
    filteredCategories() {
      if (!this.categorySearch) return this.categories

      const search = this.categorySearch.toLowerCase()
      return this.categories.filter(category =>
        category.code.toLowerCase().includes(search) ||
        category.name.toLowerCase().includes(search) ||
        category.description?.toLowerCase().includes(search) ||
        category.subCategories.some(sub =>
          sub.code.toLowerCase().includes(search) ||
          sub.name.toLowerCase().includes(search) ||
          sub.description?.toLowerCase().includes(search)
        )
      )
    }
  },
  watch: {
    'editedItem.categories': {
      handler(newCategoryId) {
        if (newCategoryId) {
          // Limpiar subrubros seleccionados al cambiar de categoría
          this.editedItem.subCategories = null
        }
      }
    },
    'editedItem._id': {
      handler() {
        this.editedItem.category = this.editedItem.category._id
        // this.editedItem.categories.subCategories = this.getSubCategories(this.editedItem.categories.category)
      }
    }
  },
  methods: {
    getSubCategories(categoryId) {
      const category = this.categories.find(c => c._id === categoryId)
      return category ? category.subCategories : []
    },
    getSubCategory(categoryId, subCategorieId) {
      const category = this.categories.find(c => c._id === categoryId)
      const subcategory = category.subCategories.find(c => c._id === subCategorieId)
      return subcategory
    },
    openCategoryDialog(category = null) {
      this.editedCategory = category
        ? { ...category }
        : {
            code: '',
            name: '',
            description: '',
            active: true
          }
      this.categoryDialog = true
    },

    closeCategoryDialog() {
      this.categoryDialog = false
      this.$nextTick(() => {
        this.editedCategory = {
          code: '',
          name: '',
          description: '',
          active: true
        }
        this.$refs.categoryForm?.reset()
      })
    },

    async saveCategory() {
      if (!this.$refs.categoryForm.validate()) return

      try {
        if (this.editedCategory._id) {
          await this.$store.dispatch('supplierCategories/update', this.editedCategory)
          this.$toast.success('Rubro actualizado')
        } else {
          await this.$store.dispatch('supplierCategories/create', this.editedCategory)
          this.$toast.success('Rubro creado')
        }
        this.closeCategoryDialog()
      } catch (error) {
        this.$toast.error('Error al guardar el rubro')
      }
    },

    async deleteCategory(category) {
      if (!confirm(`¿Estás seguro de eliminar el rubro ${category.name}?`)) return

      try {
        await this.$store.dispatch('supplierCategories/delete', category._id)
        this.$toast.success('Rubro eliminado')
      } catch (error) {
        this.$toast.error('Error al eliminar el rubro')
      }
    },

    openSubCategoryDialog(category, subCategory = null) {
      this.selectedCategory = category
      this.editedSubCategory = subCategory
        ? { ...subCategory }
        : {
            code: '',
            name: '',
            description: '',
            active: true
          }
      this.subCategoryDialog = true
    },

    closeSubCategoryDialog() {
      this.subCategoryDialog = false
      this.$nextTick(() => {
        this.selectedCategory = null
        this.editedSubCategory = {
          code: '',
          name: '',
          description: '',
          active: true
        }
        this.$refs.subCategoryForm?.reset()
      })
    },

    async saveSubCategory() {
      if (!this.$refs.subCategoryForm.validate()) return

      try {
        await this.$store.dispatch('supplierCategories/updateSubCategory', {
          categoryId: this.selectedCategory._id,
          subCategory: this.editedSubCategory
        })
        this.$toast.success('Subrubro guardado')
        this.closeSubCategoryDialog()
      } catch (error) {
        this.$toast.error('Error al guardar el subrubro')
      }
    },

    async deleteSubCategory(category, subCategory) {
      if (!confirm(`¿Estás seguro de eliminar el subrubro ${subCategory.name}?`)) return

      try {
        await this.$store.dispatch('supplierCategories/deleteSubCategory', {
          categoryId: category._id,
          subCategoryId: subCategory._id
        })
        this.$toast.success('Subrubro eliminado')
      } catch (error) {
        this.$toast.error('Error al eliminar el subrubro')
      }
    },
    openDialog(item = null) {
      this.editedItem = item ? { ...item } : { ...this.defaultItem }
      this.dialog = true
    },

    closeDialog() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.$refs.form.reset()
      })
    },

    async save() {
      if (!this.$refs.form.validate()) return

      try {
        if (this.editedItem._id) {
          await this.$store.dispatch('suppliers/update', this.editedItem)
          this.$toast.success('Proveedor actualizado')
        } else {
          await this.$store.dispatch('suppliers/create', this.editedItem)
          this.$toast.success('Proveedor creado')
        }
        this.closeDialog()
      } catch (error) {
        this.$toast.error('Error al guardar el proveedor')
      }
    },

    async toggleStatus(item) {
      try {
        await this.$store.dispatch('suppliers/toggleStatus', item._id)
        this.$toast.success(`Proveedor ${item.active ? 'desactivado' : 'activado'}`)
      } catch (error) {
        this.$toast.error('Error al cambiar el estado del proveedor')
      }
    }
  },

  async created() {
    this.loading = true
    try {
      await this.$store.dispatch('supplierCategories/fetch')
      await this.$store.dispatch('suppliers/fetch')
    } catch (error) {
      this.$toast.error('Error al cargar los proveedores')
    } finally {
      this.loading = false
    }
  }
}
</script>
